import featureFlag from './feature-flag/featureFlag';
import evidentlyFeatures from './evidently-features/evidentlyFeatures';
import trident from './trident/trident';
import collectionsService from './collections-service/collectionsService';
import cacheService from './cache-service/cacheService';
import companyService from './company-service/companyService';
import distributorService from './distributor-service/distributorService';
import permissionsService from './permissions-service/permissionsService';
import siteService from './site-service/siteService';
import platformService from './platform-service/platformService';
import analyticsService from './analytics-service/analyticsService';
import taskTypesService from './task-types-service/taskTypesService';
import utilityService from './utility-service/utilityService';
import urlService from './url-service/urlService';
import languageProvider from './language-provider/languageProvider';
import routeConfigProvider from './route-config-provider/routeConfigProvider';
import peopleService from './people-service/peopleService';
import groupsService from './groups-service/groupsService';
import layoutService from './layout-service/layoutService';
import savedSearchService from './saved-search-service/savedSearchService';
import filtersService from './filtersService/filtersService';
import pitchStatusIndex from './pitch-status-index/pitchStatusIndex';
import schemaService from './schema-service/schemaService';
import tasksService from './tasks-service/tasksService';
import storyProcessingService from './story-processing-service/storyProcessingService';
import urlConversionService from './url-conversion-service/urlConversionService';
import refineStateService from './refine-state-service/refineStateService';
import translateService from './translate-service/translateService';
import confirmationDialog from './confirmation-dialog/confirmationDialog';
import statsService from './stats-service/statsService';
import teamsService from './teams-service/teamsService';
import contentPublishWindowService from '../../stats/services/content-publish-window-service/contentPublishWindowService';

export default function (ngModule) {
  trident(ngModule);
  featureFlag(ngModule);
  evidentlyFeatures(ngModule);
  collectionsService(ngModule);
  cacheService(ngModule);
  companyService(ngModule);
  distributorService(ngModule);
  permissionsService(ngModule);
  siteService(ngModule);
  platformService(ngModule);
  analyticsService(ngModule);
  taskTypesService(ngModule);
  utilityService(ngModule);
  urlService(ngModule);
  languageProvider(ngModule);
  routeConfigProvider(ngModule);
  peopleService(ngModule);
  groupsService(ngModule);
  layoutService(ngModule);
  savedSearchService(ngModule);
  filtersService(ngModule);
  pitchStatusIndex(ngModule);
  schemaService(ngModule);
  tasksService(ngModule);
  storyProcessingService(ngModule);
  urlConversionService(ngModule);
  refineStateService(ngModule);
  translateService(ngModule);
  confirmationDialog(ngModule);
  statsService(ngModule);
  teamsService(ngModule);
  contentPublishWindowService(ngModule);
}
